<div class="main-wrapper">
    <div class="main-title">
        <h1>
            Media Hub
        </h1>
        <h2>
            We are in the spotlight! We have been interviewed on television news channels, written about in newspapers, featured in magazines, journals and websites. Check it all out!
        </h2>
        <p>
            If you have any media or press enquiries, please contact Ms. Mamta Jaiswal - PR Manager - pr@ketto.org
        </p>
    </div>
    <div class="press-club-list" *ngIf="!isLoading">
        <app-press-club-item [pressClubItem]="pressClub" *ngFor="let pressClub of pressClubList" />
    </div>
    <div class="spinner" *ngIf="isLoading">
        <mat-spinner class="text-center" [diameter]="70"></mat-spinner>
    </div>
    <div class="press-club-paginator">
        <app-button label="First"
            (click)="getPressClubData('init')"
            [disabled]="isLoading || currentPage === 1"></app-button>
        <app-button btnClass="icon"
            iconName="chevron_left"
            [disabled]="isLoading ||currentPage === 1"
            (click)="getPressClubData('prev')"></app-button>
        <span class="currentPage">{{currentPage}}</span>
        <app-button btnClass="icon"
            iconName="chevron_right"
            [disabled]="isLoading || currentPage === lastPage"
            (click)="getPressClubData('next')"></app-button>
        <app-button label="Last"
            (click)="getPressClubData('last')"
            [disabled]="isLoading || currentPage === lastPage"></app-button>
    </div>
</div>
